import { client } from '..';
import { CreateManyAmenitiesParams } from '../models/amenityModels';

export const createManyAmenities = async (body: { amenities: CreateManyAmenitiesParams[] }): Promise<any> => {
  const url = '/amenities/many';

  const { data } = await client.post(url, body);

  return data;
};
